import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'

import Hero from '@/components/Inicio/Hero'
import Carousel from '@/components/Carousel'
import FeatureList from '@/components/FeatureList'
import ClubLT from '@/components/ClubLT'
import Planes from '@/components/Planes'

const IndexPage = () => (
  <Layout>
    <SEO
      title="La Tercera - Suscripción digital"
      keywords={[`La Tercera`, `suscripción`, `Diario digital`, `digital`]}
    />
    <Hero />
    <Carousel
      titulo="Nuestras comunidades, tus intereses."
      bajada="Sé parte de la mayor comunidad de medios de Chile."
    />
    <FeatureList />
    <ClubLT />
    <Planes />
  </Layout>
)

export default IndexPage
